<template>
  <div>
    <div class="stepContent">
      <el-row>
        <el-col :span="24" class="box-card-content-edit">
          <el-row>
            <el-col :span="12">
              <span class="cs-videoApp-campusLabel" v-if="!isView">{{ timeModel.campusName }}</span>
              <span v-if="isReadOnly">{{ timeModel.appDateText }}</span>
              <el-date-picker size="small" v-else align="center" format="yyyy/MM/dd" :picker-options="pickerOptions"
                v-model="timeModel.appDate" type="date" placeholder="选择预约时间" @change="onDatechange"></el-date-picker>

              <div v-if="isView">
                <span class="cs-videoApp-campusLabel" v-if="isReadOnly">{{ timeModel.campusName }}</span>
                <el-select v-else v-model="timeModel.campusId" placeholder="请选择校区" @change="onCampusChange">
                  <el-option v-for="(item, index) in campusList" :key="index" :label="item.Name"
                    :value="item.Id"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div v-if="dataIn.hasOwnDevice">
                <div v-if="isView || isReadOnly">
                  <span class="cs-videoApp-scheduleLabel" v-if="timeModel.isOwnDevice">{{ ownDeviceName }}</span>
                </div>
                <div v-else>
                  <el-checkbox size="small" v-model="timeModel.isOwnDevice" class="input-width"
                    @change="onIsOwnDeviceChange">{{ ownDeviceName }}</el-checkbox>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="!isView" class="cs-videoApp-descRow">
            <el-col :span="12">
              <span>请点击日程表单元格添加预约</span>
            </el-col>
            <el-col :span="12">
              <span>可观看时长:&nbsp;{{ availableMinutesText }}</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <br>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <courseCalendar v-loading="isLoading" ref="courseCalendar" :options="calendarOptions"
            @editBlock="editSchedule" :schedules="videoAppointmentSchedule" @add="onAddSchedule"></courseCalendar>
        </el-col>
      </el-row>
      <el-dialog title="选择时间" :center="true" :close-on-click-modal="false" :visible.sync="selectTimeVisible" top="8vh">
        <avappSelectTimeEdit :dataIn="selectTimeData" @save="onSaveSchedule" @delete="onDeleteSchedule"
          class="popup-window"></avappSelectTimeEdit>
      </el-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-videoApp-campusLabel {
  display: inline-block;
  margin-right: 10px;
}

.cs-videoApp-scheduleLabel {
  display: inline-block;
}

.cs-videoApp-descRow {
  margin-top: 10px;
}
</style>

<script>
import courseCalendar from "../courseCalendar";
import avappSelectTimeEdit from "./avappSelectTimeEdit";

import {
  formatDate,
  formatMinutes,
  formatTimeToInt60,
  guid,
  formatTimeFromInt60
} from "../../config/mUtils";
import {
  getCampusList,
  getVideoAppCampusList,
  getComputerListByCampusId
} from "../../service/common.service";
import { getScheduleList } from "../../service/videoAppointment.service";

let moment = require("moment");

export default {
  props: {
    isCompleted: Boolean,
    isView: Boolean,
    isReadOnly: Boolean,
    dataIn: {
      studentId: Number,
      videoAppointmentId: Number,
      courseId: Number,
      courseName: String,
      isOneHour: Boolean,
      availableMinutes: Number,
      courseMinutes: Number,
      hasOwnDevice: Boolean, //是否有自带设备选项,某些课程不允许自带电脑
      model: Object
    }
  },
  data() {
    return {
      campusList: [],
      allComputerList: [],
      computerList: [],
      defaultComputer: null,
      videoAppointmentSchedule: [],
      studentUniversityGroupNumber: 0,
      timeModel: {
        campusId: 0,
        campusName: "",
        appDate: "",
        appDateText: "",
        isOwnDevice: false,
        minutes: 0
      },
      selectTimeVisible: false,
      selectTimeData: {},
      pickerOptions: {},
      calendarOptions: {},
      schedulesData: [],
      availableScheduleList: {},
      scheduleResultData: {},
      computerSchedulesData: {},
      colorList: ["#bbc7d4", "#006ab4"],
      isBtnDisabled: false,
      submitBtnClass: "primary",
      isSaving: false,
      isLoading: false,
      minTime: formatTimeToInt60("8:00 AM"),
      maxTime: formatTimeToInt60("11:00 PM"),
      isMinMaxTimeReloading: false,
      dateFormat: "YYYY/MM/DD",
      ownDeviceName: "自带电脑/平板和耳机",
      availableMinutesText: "",
      fixedTimeRange: false,
      timeLengthList: [],
      minuteScale: 30,
    };
  },
  components: {
    courseCalendar,
    avappSelectTimeEdit
  },
  created() {
    this.initData();
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.model) {
        this.availableMinutesText = formatMinutes(this.dataIn.availableMinutes, true);
        this.timeModel = this.dataIn.model;
        if (!this.timeModel.appDateText) {
          this.timeModel.appDate = moment().toDate();
        } else {
          this.timeModel.appDate = moment(this.timeModel.appDateText).toDate();
        }

        this.loadTimeLengthList();
        this.loadCampusList();
      } else {
        this.timeModel = {
          campusId: 0,
          campusName: "",
          appDate: "",
          appDateText: "",
          isOwnDevice: false,
          minutes: 0,
        };

        if (this.isView) {
          this.timeModel.appDate = moment().toDate();
          this.loadTimeLengthList();
          this.loadCampusList();
        }
      }
      //this.loadScheduleList();
    },
    onDeleteSchedule(id) {
      let schedule = this.schedulesData.find(i => i.Id == id);

      if (
        !!schedule &&
        schedule.IsMine &&
        schedule.VideoAppointmentId == this.dataIn.videoAppointmentId
      ) {
        let index = this.schedulesData.findIndex(i => i.Id == id);
        this.schedulesData.splice(index, 1);
        this.loadComputerSchedulesData(schedule.ComputerId);
        this.selectTimeVisible = false;
        this.refreshCalander();
      }
    },
    onSaveSchedule(data) {
      let computerId = this.selectTimeData.computerId;
      let previousComputerId = computerId;
      let computerName = this.selectTimeData.computerName;
      if (!this.fixedTimeRange && !this.timeModel.isOwnDevice) {
        computerId = data.computerId;
        computerName = data.computerName;
      }
      let schedule = {
        Id: data.id,
        VideoAppointmentId: this.dataIn.videoAppointmentId,
        ComputerId: computerId,
        ComputerName: computerName,
        CampusName: this.timeModel.campusName,
        DateText: this.selectTimeData.date,
        IsMine: true,
        StartTimeText: formatTimeFromInt60(data.startTime),
        EndTimeText: formatTimeFromInt60(data.endTime)
      };
     
      let index = -1;
      if (schedule.Id){
        index = this.schedulesData.findIndex(i => i.Id == schedule.Id);
      }
      if (index < 0){
        index = this.schedulesData.findIndex(i => i.VideoAppointmentId == schedule.VideoAppointmentId);
      }

      if (index < 0) {
        if (!schedule.Id){
          schedule.Id = guid();
        } 
        this.schedulesData.push(schedule);
      } else {
        previousComputerId = this.schedulesData[index].ComputerId;
        this.schedulesData[index] = schedule;
      }
      this.timeModel.minutes = data.minutes;
      this.loadComputerSchedulesData(computerId);
      if (previousComputerId != computerId){
        this.loadComputerSchedulesData(previousComputerId);
      }
      this.refreshCalander();
      this.selectTimeVisible = false;
    },
    editSchedule(keyValue) {
      if (this.isReadOnly || this.isView) {
        return;
      }

      let schedule = this.schedulesData.find(i => i.Id == keyValue);
      if (
        !!schedule &&
        schedule.IsMine &&
        schedule.VideoAppointmentId == this.dataIn.videoAppointmentId
      ) {
        this.showEdit(schedule.Id, schedule.ComputerId, schedule.StartTimeText, true);
      }
    },
    onAddSchedule(data) {
      if (this.isReadOnly || this.isView || !data || !data.startTime) {
        return;
      }
      
      let computerId = data.key;
      let value = formatTimeToInt60(data.startTime);
      if (value == this.hourStart * 60) {
        return;
      }
      //开始时间需要减去30分钟(已废弃)
      //value -= 30;
      if (value < this.minTime) {
        value = this.minTime;
      }
      let startTime = formatTimeFromInt60(value);

      //如果已有预约记录，进行编辑
      let schedule = this.schedulesData.find(
        i => i.IsMine && i.VideoAppointmentId == this.dataIn.videoAppointmentId
      );
 
      if (!!schedule) {
        this.showEdit(schedule.Id, schedule.ComputerId, schedule.StartTimeText, true);
        //this.showEdit(schedule.Id, computerId, startTime);
        return;
      }

      if (!this.validScheduleCount()) {
        return;
      }

      this.showEdit(null, computerId, startTime);
    },
    add(data) { },
    validScheduleCount(showMessage) {
      //每天只能添加3次
      let schedules = this.schedulesData.filter(
        i => i.IsMine && i.VideoAppointmentId != this.dataIn.videoAppointmentId
      );
      if (schedules.length >= 3) {
        if (showMessage) {
          this.$message.warning("每天最多只能预约3门课程，已达到预约数量上限");
        }
        return false;
      }
      return true;
    },
    showEdit(id, computerId, startTime, isEdting) {
     
      if (this.isMinMaxTimeReloading) return;
      let computerName = "";
      let computer = this.allComputerList.find(i => i.Id == computerId);
      if (!computer) {
        return;
      }

      computerName = computer.ComputerName;
      if (this.timeModel.isOwnDevice) {
        computerName = this.ownDeviceName;
      } else if (!this.fixedTimeRange && !isEdting) {
        computerId = 0;
        computerName = "";
        startTime = "";
      }

      let scheduleList = this.schedulesData.filter(
        i => (i.ComputerId == computerId && this.fixedTimeRange) || i.IsMine
      );
      
      let unavailableTime = [];
      scheduleList.forEach(i => {
        if (
          i.Id == id ||
          i.VideoAppointmentId == this.dataIn.videoAppointmentId
        ) {
          return;
        }
        let startTimeValue = formatTimeToInt60(i.StartTimeText);
        let endTimeValue = formatTimeToInt60(i.EndTimeText, true);

        let item = {
          startTime: startTimeValue,
          endTime: endTimeValue,
          isSchedule: true
        };
        unavailableTime.push(item);
      });
      //如果是当天预约，之前的时间也不可用
      let todayUnavailableTime = this.getTodayUnavailableTime();
      if (!!todayUnavailableTime) {
        unavailableTime.push(todayUnavailableTime);
      }
     
      //如果电脑未启用，所有时间不可用
      if (!!computer && !computer.IsActive) {
        unavailableTime.push({
          startTime: this.minTime,
          endTime: this.maxTime,
          isSchedule: false
        });
      }

      let isEdit = true;
      if (!id) {
        isEdit = false;
      }
      let minutes = this.timeModel.minutes;
      if (this.timeModel.isOwnDevice){
        minutes = this.dataIn.courseMinutes;
      }

      this.selectTimeData = {
        isEdit: isEdit,
        id: id,
        date: moment(this.timeModel.appDate).format("L"),
        campus: this.timeModel.campusName,
        computerId: computerId,
        computerName: computerName,
        unavailableTime: unavailableTime,
        startTime: startTime,
        minutes: minutes,
        isOwnDevice: this.timeModel.isOwnDevice,
        fixedTimeRange: this.fixedTimeRange,
        minTime: this.minTime,
        maxTime: this.maxTime,
        availableScheduleList: this.availableScheduleList,
        computerSchedulesData: this.computerSchedulesData,
        computerList: this.computerList,
        timeLengthList: this.timeLengthList
      }; 
      this.selectTimeVisible = true;
    },
    getTodayUnavailableTime() {
      if (moment(this.timeModel.appDate).format("L") == moment().format("L")) {
        let now = new Date();
        let hour = now.getHours();
        let minutes = now.getMinutes();
        let nowValue = hour * 60 + minutes + 5;
        if (nowValue >= this.minTime){
          return {
            startTime: this.minTime,
            endTime: nowValue
          };
        }
        return null;
      }

      return null;
    },
    getCalendarOptions() {
      let headers = [];

      let searchDateText = moment(this.timeModel.appDate).format(this.dateFormat);
      let list = null;
      if (this.timeModel.isOwnDevice) {
        list = [this.defaultComputer];
      } else {
        list = this.computerList;
      }
      list.forEach(element => {
        let item = {
          key: element.Id,
          value: element.ComputerName,
          disabled: !element.IsActive,
          unavailableTimeItems: []
        };

        //读取电脑不可用时间段设置
        if (!!element.ComputerUnavailableTimeSchedules && element.ComputerUnavailableTimeSchedules.length > 0) {
          var self = this;
          element.ComputerUnavailableTimeSchedules.forEach(function (cutSchedule, index) {
            let startDate = new Date(cutSchedule.StartDate);
            let endDate = new Date(cutSchedule.EndDate);
            if (self.timeModel.appDate < startDate || self.timeModel.appDate > endDate)
              return;

            item.unavailableTimeItems.push({
              startTime: formatTimeToInt60(cutSchedule.StartTimeText),
              endTime: formatTimeToInt60(cutSchedule.EndTimeText, true),
              isSchedule: false
            });
          });
        }

        headers.push(item);
      });

      let todayUnavailableTime = this.getTodayUnavailableTime();

      let options = {
        start: this.minTime / 60,
        end: this.maxTime / 60,
        hasCustomHeader: true,
        headers: headers,
        unavailableTime: todayUnavailableTime,
      };
      this.calendarOptions = options;
    },
    refreshCalander() {
      let scheduleList = [];
      this.schedulesData.forEach(element => {
        let color = this.colorList[0];
        let fontColor = "";
        let text = "已预约";
        if (element.IsMine) {
          if (element.VideoAppointmentId == this.dataIn.videoAppointmentId) {
            color = this.colorList[1];
            text = "我的预约";
          } else {
            color = this.colorList[0];
            text = "我的预约-" + element.CourseName;
          }
        } else {
          fontColor = "#89929c";
          text = `已预约-${element.CourseName}` + " " + element.StartTimeText + "-" + element.EndTimeText;
        }

        let item = {
          color: color,
          fontColor: fontColor,
          starttime: element.StartTimeText,
          endtime: element.EndTimeText,
          groupKey: element.ComputerId,
          title: text,
          //text: text,
          keyValue: element.Id
        };
        scheduleList.push(item);
      });

      this.videoAppointmentSchedule = scheduleList;
      this.refreshbtn();
    },
    onDatechange() {
      this.reload();
    },
    onIsOwnDeviceChange() {
      //this.reload();
      this.getCalendarOptions();
      this.reloadScheduleList();
    },
    reload() {
      this.loadMinMaxTime();
      this.getCalendarOptions();
      this.loadScheduleList();
    },
    loadScheduleList() {
      if (
        !!this.timeModel &&
        !!this.timeModel.appDate &&
        !!this.timeModel.campusId
      ) {
        this.isLoading = true;
        let date = moment(this.timeModel.appDate).format("L");
        getScheduleList(
          this.dataIn.studentId,
          date,
          this.timeModel.campusId,
          this.dataIn.videoAppointmentId,
          this.dataIn.isOneHour
        )
          .then(result => {
            if (!!result && result.success) {
              this.scheduleResultData = result.data;
              this.reloadScheduleList();
            }
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
          });
      } else {
        this.schedulesData = [];
        this.computerSchedulesData = [];
      }
    },
    reloadScheduleList(){
      let scheduleList = JSON.parse(JSON.stringify( this.scheduleResultData.ScheduleList));
      //自带设备只显示当前预约
      if (this.timeModel.isOwnDevice) {
        scheduleList = scheduleList.filter(i => i.IsMine);// && i.VideoAppointmentId == this.dataIn.videoAppointmentId);
      }

      let scheduleIndex = scheduleList.findIndex(
        i => i.IsMine && i.VideoAppointmentId == this.dataIn.videoAppointmentId
      );
      if (scheduleIndex >= 0) {
        let isRemove = false;
        let schedule = scheduleList[scheduleIndex];

        if (this.timeModel.isOwnDevice) {
          if (this.defaultComputer && schedule.ComputerId != this.defaultComputer.Id) {
            isRemove = true;
          }
        } else {
          let computerIndex = this.computerList.findIndex(i => i.Id == schedule.ComputerId);
          if (computerIndex < 0) {
            isRemove = true;
          }
        }
        if (isRemove) {
          scheduleList.splice(scheduleIndex, 1);
        }
      }
      this.schedulesData = scheduleList;
      let list = this.scheduleResultData.AvailableScheduleList;
      this.availableScheduleList = {};
      this.computerSchedulesData = {};
      
      for (let i = 0; i < this.computerList.length; i++) {
        let computer = this.computerList[i];
        let computerId = computer.Id;
        this.availableScheduleList[computerId] = list.filter(i => i.ComputerId == computerId);
        this.loadComputerSchedulesData(computerId);
      }

      this.refreshCalander();
      this.validScheduleCount(true);
    },
    loadComputerSchedulesData(computerId){ 
      this.computerSchedulesData[computerId] = this.schedulesData.filter(i => i.ComputerId == computerId);
    },
    initData() {
      //this.loadCampusList();
      this.setDateOptions();
    },
    async loadCampusList() {
      if (this.dataIn && this.dataIn.courseId) {
        let result = await getVideoAppCampusList(this.dataIn.courseId);

        if (!!result && result.success) {
          this.campusList = result.data;
          if (this.campusList.length > 0) {
            this.loadCampus();
          }
        }
      } else {
        if (this.isView) {
          let result = await getCampusList();
          if (!!result && result.success) {
            this.campusList = result.data;
            if (this.campusList.length > 0) {
              this.loadCampus();
            }
          }
        } else {
          this.campusList = [];
        }
      }
    },
    async loadComputersByCampusId() {
      let result = await getComputerListByCampusId(this.timeModel.campusId);
      if (!!result && result.success) {
        this.allComputerList = result.data;
        //校区电脑
        this.computerList = this.allComputerList.filter(i => !i.IsDefault);
        //自带电脑
        this.defaultComputer = this.allComputerList.find(i => i.IsDefault);
        this.getCalendarOptions();
        this.loadScheduleList();
      }
    },
    setDateOptions() {
      this.pickerOptions = {
        disabledDate: time => {
          let today = moment().toDate();
          const curDate = today.getTime();
          const day = 7 * 24 * 3600 * 1000;
          const dateRegion = curDate + day;
          return (
            time.getTime() < today - 8.64e7 || time.getTime() > dateRegion
            //time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      };
    },
    onCampusChange() {
      this.loadCampus();
    },
    loadCampus() {
      if (
        !this.timeModel.campusId &&
        (!this.campusList || this.campusList.length == 0)
      ) {
        return;
      }
      if (!this.timeModel.campusId) {
        let defaultCampus = this.campusList.find(i => i.IsDefault);

        if (!!defaultCampus) {
          this.timeModel.campusId = defaultCampus.Id;
        } else {
          this.timeModel.campusId = this.campusList[0].Id;
        }
      }
      let campus = this.campusList.find(c => c.Id == this.timeModel.campusId);
      if (!!campus) {
        this.timeModel.campusName = campus.Name;
      }

      this.loadMinMaxTime();

      this.loadComputersByCampusId();
    },
    loadMinMaxTime() {
      this.isMinMaxTimeReloading = true;
      let schedule = null;
      if (
        !!this.timeModel &&
        !!this.timeModel.appDate &&
        !!this.timeModel.campusId
      ) {
        let campus = this.__findCampus(this.timeModel.campusId);
        if (!!campus)
          schedule = this.__findCampusTimeSchedule(
            campus.CampusTimeSchedules,
            this.timeModel.appDate.getDay()
          );
      }

      this.minTime = formatTimeToInt60(
        !!schedule ? schedule.StartTimeText : "8:00 AM"
      );
      this.maxTime = formatTimeToInt60(
        !!schedule ? schedule.EndTimeText : "11:00 PM",
        true
      );
      this.isMinMaxTimeReloading = false;
    },
    getData() {
      let schedule = this.schedulesData.find(
        i => i.IsMine && i.VideoAppointmentId == this.dataIn.videoAppointmentId
      );
      this.refreshbtn();
      let data = {
        campusId: this.timeModel.campusId,
        campusName: this.timeModel.campusName,
        appDate: moment(this.timeModel.appDate).format("L"),
        schedule: schedule
      };
      return data;
    },
    refreshbtn() {
      if (this.schedulesData.findIndex(i => i.IsMine) >= 0) {
        this.isBtnDisabled = true;
        this.submitBtnClass = "info";
      } else {
        this.isBtnDisabled = false;
        this.submitBtnClass = "primay";
      }
    },
    valid() {
      let schedule = this.schedulesData.find(
        i => i.IsMine && i.VideoAppointmentId == this.dataIn.videoAppointmentId
      );

      if (!schedule) {
        this.$message.warning("当前日期没有任何预约");
        return false;
      }

      let isValidDate = false;

      if (!!schedule.DateText) {
        let m = moment(schedule.DateText);
        isValidDate = m.isValid();
      }
      if (!isValidDate) {
        this.$message.warning("日期格式错误，请刷新页面后重试");
        return false;
      }

      let computer = this.allComputerList.find(i => i.Id == schedule.ComputerId);
      if (!computer || !computer.IsActive) {
        this.$message.warning("当前预约电脑不可用");
        return false;
      }

      return true;
    },
    refreshCalendar() {
      this.$refs.courseCalendar.refresh();
    },
    __findCampus(campusId, campusList = this.campusList) {
      let findResult = null;

      for (let i = 0; i < campusList.length; i++) {
        let campus = campusList[i];
        if (campus.Id == campusId) {
          findResult = campus;
          break;
        }
      }

      return findResult;
    },
    __findCampusTimeSchedule(schedules, dayOfWeek, campusId = null) {
      let findResult = null;

      if (!!schedules) {
        for (let i = 0; i < schedules.length; i++) {
          let schedule = schedules[i];
          if (
            schedule.DayOfWeek == dayOfWeek &&
            (!campusId || schedule.CampusId == campusId)
          ) {
            findResult = schedule;
            break;
          }
        }
      }

      return findResult;
    },
    loadTimeLengthList() {
      let list = [];
      let minutes = this.dataIn.courseMinutes;
      if (minutes > this.dataIn.availableMinutes) {
        minutes = this.dataIn.availableMinutes;
      }
      let count = Math.floor(minutes / this.minuteScale);
      if (minutes % this.minuteScale > 1) {
        count++;
      }
      if (count > 0) {
        for (let i = 1; i <= count; i++) {
          let currentMinutes = this.minuteScale * i;
          let name = formatMinutes(currentMinutes, true);
          let item = {
            name: name,
            value: currentMinutes
          }
          list.push(item);
        }
        this.timeLengthList = list;
      }
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappWorkflowStep2.vue